import styled from 'styled-components';
import { borderRadius, colors } from 'ui/theme';
import { Disable16 } from 'ui/icons/aurora/16px/Disable16';
import { getIconColor, isOptionSelected } from './utils';

const StyledDisableIcon = styled(Disable16)`
  border-radius: ${borderRadius.xl};
  border: 2px solid ${colors.salmon50};

  &[data-selected='false'] {
    border-color: ${colors.textSecondary};
  }
`;

export const NotIcon = ({ color }: { color?: string }) => {
  const isSelected = isOptionSelected(color);
  return (
    <StyledDisableIcon data-selected={isSelected} color={getIconColor(colors.salmon50, color)} />
  );
};
